<ng-container *ngIf="mainForm !== undefined && control">
  <div class="textareaField {{layoutModifier}}" [formGroup]="mainForm"
    [ngClass]="{'textareaField_error': control.invalid && (control.dirty || control.touched)}">
    <textarea type="textarea" [formControlName]="controlName"></textarea>
  </div>
  <app-form-errors [control]="control"></app-form-errors>
</ng-container>
